<script setup lang="ts">
const $props = withDefaults(defineProps<{
  modelValue?: boolean
}>(), {
  modelValue: false,
})

const emits = defineEmits<{
  (e: 'update:modelValue', data: boolean): void
  (e: 'confirm'): void
}>()

const visibleRef = useModel($props, 'modelValue')

function onConfirm() {
  visibleRef.value = false
  emits('confirm')
}
</script>

<template>
  <ClientOnly>
    <AModal
      v-model:open="visibleRef"
      wrapClassName="ant-cover__basic-modal"
      :width="480"
      closable
      centered
      :maskClosable="false"
      :title="$t('lqyYiri9qSjxM_7Scgcbp')"
      :footer="null"
    >
      <div class="w-full">
        <div class="flex justify-center mt-6">
          <img src="@/assets/imgs/auto-leasing-login-confirm.svg" alt="Failed to load">
        </div>
        <div class="text-[18px] leading-7 text-center mt-2.5 mb-6 text-[#E2E8F2]">{{ $t('wregFq1AudnNsA7qApdDy') }}</div>
      </div>
      <div class="w-full text-center">
        <AButton class="w-[70%] text-sm comfirm-btn" data-test-id="dqrs" @click="onConfirm">
          {{ $t('iLSgAhANt710VpwWkTxn2') }}
        </AButton>
      </div>
    </AModal>
  </ClientOnly>
</template>
